export class PaymentVoucher {
  constructor(data) {
    this.voucherProgramName = data.voucherProgramName || "";
    this.voucherProgramCode = data.voucherProgramCode || "";
    this.amountCollect = data.amountCollect || 0;
    this.voucherProgramType = data.voucherProgramType || 0;
  }
}